module.exports = __webpack_public_path__ + "static/img/20001 (7).043d56e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20001 (7).webp
// module id = jazO
// module chunks = 14